var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 562,
    height: 300,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    fill: "#F9FAFD"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 562,
    height: 300,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 561,
    height: 299,
    rx: 5.5,
    stroke: "#EFF2F5"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M281 260c60.75 0 110-49.25 110-110S341.75 40 281 40 171 89.25 171 150s49.25 110 110 110Z",
    fill: "#A2B5E6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M305.06 65.78a6.9 6.9 0 0 1-6.87-6.87 6.9 6.9 0 0 1 6.87-6.88 6.9 6.9 0 0 1 6.88 6.88 6.9 6.9 0 0 1-6.88 6.87Zm0-10.48a3.63 3.63 0 0 0-3.6 3.6 3.63 3.63 0 0 0 3.6 3.62 3.63 3.63 0 0 0 3.61-3.61 3.52 3.52 0 0 0-3.6-3.61Zm-41.25 185.8a6.9 6.9 0 0 1-6.87-6.88 6.9 6.9 0 0 1 6.87-6.88 6.9 6.9 0 0 1 6.88 6.88 6.9 6.9 0 0 1-6.88 6.87Zm0-10.5a3.63 3.63 0 0 0-3.6 3.62c0 2.06 1.71 3.6 3.6 3.6a3.63 3.63 0 0 0 3.61-3.6 3.52 3.52 0 0 0-3.6-3.61Zm-6.7-171.87c0-.68.69-1.37 1.72-1.54l3.27-.52c.86-.17 1.89-1.03 1.89-1.89l.51-3.27c.18-.85.86-1.71 1.55-1.71.69 0 1.38.68 1.55 1.71l.51 3.27c.17.86 1.03 1.9 1.9 1.9l3.26.5c.86.18 1.72.87 1.72 1.55 0 .7-.69 1.38-1.72 1.55l-3.44.34c-.86.18-1.89 1.04-1.89 1.9l-.51 3.26c-.18.86-.87 1.72-1.55 1.72-.69 0-1.38-.69-1.55-1.72l-.51-3.6a2.63 2.63 0 0 0-1.9-1.9l-3.09-.17c-1.03-.17-1.72-.69-1.72-1.38Z",
    fill: "#F9FAFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.53 194.69a13.8 13.8 0 0 1-13.75 13.75h-165a13.8 13.8 0 0 1-13.75-13.75V88.13a13.8 13.8 0 0 1 13.75-13.75h165c7.56 0 13.75 6.18 13.75 13.75v106.56Z",
    fill: "#062147",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.78 211.88h-165a15.4 15.4 0 0 1-15.47-15.47V89.84a15.4 15.4 0 0 1 15.47-15.47h165a15.4 15.4 0 0 1 15.47 15.47v106.57a15.4 15.4 0 0 1-15.47 15.47Zm-165-134.07c-6.7 0-12.03 5.33-12.03 12.03v106.57c0 6.7 5.33 12.03 12.03 12.03h165c6.7 0 12.03-5.33 12.03-12.03V89.84c0-6.7-5.33-12.03-12.03-12.03h-165Z",
    fill: "#062147",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.22 196.4a6.9 6.9 0 0 1-6.88 6.88H200.22a6.9 6.9 0 0 1-6.88-6.87V95a6.9 6.9 0 0 1 6.88-6.88h158.12a6.9 6.9 0 0 1 6.88 6.88v101.4Z",
    fill: "#4075BF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m246.38 138.38-3.93 3.93a4.96 4.96 0 0 0 7 7l3.93-3.93 3.93 3.93a4.96 4.96 0 0 0 7-7l-3.93-3.93 3.93-3.93a4.96 4.96 0 0 0-7-7l-3.93 3.93-3.93-3.93a4.96 4.96 0 0 0-7 7l3.93 3.93Zm54.48 0-3.93 3.93a4.96 4.96 0 0 0 7 7l3.93-3.93 3.93 3.93a4.96 4.96 0 0 0 7-7l-3.93-3.93 3.93-3.93a4.96 4.96 0 0 0-7-7l-3.93 3.93-3.93-3.93a4.96 4.96 0 0 0-7 7l3.93 3.93Zm-42.26 31.66s4.3 2.17 7.24 3.63a10.9 10.9 0 0 0 9.75 0l4.59-2.3c.27-.13.6-.13.88 0l4.59 2.3a10.9 10.9 0 0 0 9.75 0l7.24-3.63a4.95 4.95 0 1 0-4.43-8.85l-7.25 3.62a.98.98 0 0 1-.88 0l-4.59-2.3a10.9 10.9 0 0 0-9.75 0l-4.59 2.3a.98.98 0 0 1-.88 0l-7.25-3.62a4.95 4.95 0 1 0-4.43 8.85Z",
    fill: "#ECF2FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.34 205H200.22a8.51 8.51 0 0 1-8.6-8.6V95c0-4.81 3.79-8.6 8.6-8.6h158.12c4.82 0 8.6 3.79 8.6 8.6v101.4c0 4.82-3.78 8.6-8.6 8.6ZM200.22 89.84a5.06 5.06 0 0 0-5.16 5.16v101.4a5.06 5.06 0 0 0 5.16 5.16h158.12a5.06 5.06 0 0 0 5.16-5.15V95a5.06 5.06 0 0 0-5.16-5.16H200.22Z",
    fill: "#062147",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.72 196.4v12.2c0 6.03 4.64 8.43 10.66 8.43h194.9c6.02 0 9.28-2.4 9.28-8.42v-12.2H172.72Z",
    fill: "#EFF2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.72 196.4v11.35c0 6.02 5.84 9.28 11.86 9.28h194.9c6.02 0 9.97-3.26 9.97-9.28v-11.34H172.72Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.66 196.4v5.5c0 1.72 3.43 3.1 5.15 3.1h33.35c1.71 0 4.64-1.38 4.64-3.1v-5.5h-43.14Zm128.9 17.2c0-3.44 1.55-5.16-.86-5.16H177.02a4.26 4.26 0 0 0-4.3 4.3c0 2.4 1.89 4.3 4.3 4.3h206.25c2.4 0 4.3-3.45 4.3-3.45Z",
    fill: "#EFF2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.31 218.75H184.58c-6.7 0-13.58-3.78-13.58-11v-11.34c0-1.03.69-1.72 1.72-1.72h216.56c1.03 0 1.72.69 1.72 1.72v11.34c0 6.7-4.47 11-11.69 11Zm-204.87-20.63v9.63c0 4.98 4.98 7.56 10.14 7.56h194.9c3.1 0 8.25-1.03 8.25-7.56v-9.63h-213.3Z",
    fill: "#062147",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M378.97 203.28H363.5c-1.03 0-1.72-.69-1.72-1.72s.69-1.72 1.72-1.72h15.47c1.03 0 1.72.7 1.72 1.72 0 1.03-.69 1.72-1.72 1.72Zm-29.22 0h-37.81c-1.03 0-1.72-.69-1.72-1.72s.69-1.72 1.72-1.72h37.81c1.03 0 1.72.7 1.72 1.72 0 1.03-.69 1.72-1.72 1.72Zm-101.41 0h-63.59c-1.03 0-1.72-.69-1.72-1.72s.69-1.72 1.72-1.72h63.6c1.03 0 1.71.7 1.71 1.72 0 1.03-.69 1.72-1.72 1.72Z",
    fill: "#255DAD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.27 84.69h-6.36c-1.03 0-1.9-.69-1.9-1.72s.87-1.72 1.9-1.72h6.36c1.03 0 1.89.69 1.89 1.72s-.86 1.72-1.9 1.72Z",
    fill: "#062147",
    fillOpacity: 0.85
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 562,
    height: 300,
    rx: 6,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 220,
    height: 220,
    fill: "#fff",
    transform: "translate(171 40)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorPlaceholder);
export default __webpack_public_path__ + "static/media/errorPlaceholder.277608a81cfa0621d9ed0228675c961a.svg";
export { ForwardRef as ReactComponent };